import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=6d4b8908&scoped=true&"
import script from "./EventsCalendar.vue?vue&type=script&lang=ts&"
export * from "./EventsCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b8908",
  null
  
)

export default component.exports